import React from 'react';
import { getAllUnreadAmount } from 'api/inbox';
import InboxStore from 'store/Inbox';

const useInboxAllUnreadCount = (): [number | undefined, boolean, () => void] => {
    const [get, set] = InboxStore.useStore();
    const [count, setConut] = React.useState<number | undefined>(get('allUnreadCount') || undefined);
    const loading = !!get('loadingAllUnreadAmount');
    const fetchData = async () => {
        try {
            set('loadingAllUnreadAmount', true);
            const result = await getAllUnreadAmount();
            if (!result.error) {
                setConut(result?.data?.data || 0);
                set('allUnreadCount', result?.data?.data || 0);
            }
            set('loadingAllUnreadAmount', false);
        } catch (e) {
            console.error(e);
            set('loadingAllUnreadAmount', false);
        }
    };
    React.useEffect(() => {
        setConut(get('allUnreadCount'));
    }, [get('allUnreadCount')]);
    React.useEffect(() => {
        if (!loading && count === undefined) {
            fetchData();
        }
    }, []);

    return [count, loading, fetchData];
};

export default useInboxAllUnreadCount;
